export default function HomeFeatures() {
  const features = [
    {
      icon: 'ri-hd-line',
      title: '高清画质',
      description: '1080P超清画质，不缓冲不卡顿，畅享极致观影体验',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速播放',
      description: '全球CDN加速节点，秒开秒播，追剧快人一步',
    },
    {
      icon: 'ri-advertisement-line',
      title: '免广告观看',
      description: '全程无广告干扰，沉浸式观影，不错过每一个精彩瞬间',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日更新',
      description: '热门剧集每日更新，追剧不等待，与剧情同步',
    },
    {
      icon: 'ri-database-2-line',
      title: '海量资源',
      description: '收录海内外热门电视剧，古装都市悬疑任君挑选',
    },
    {
      icon: 'ri-device-line',
      title: '多端同步',
      description: '电脑手机平板无缝切换，随时随地继续追剧',
    },
  ];

  return (
    <section className="w-full bg-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
              为什么选择天堂影视
            </h2>
            <p className="text-sm text-foreground-400 mt-2">六大核心优势，打造极致追剧体验</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}